import { render, staticRenderFns } from "./PsotAddEditPpot.vue?vue&type=template&id=3415f9e1&scoped=true&"
import script from "./PsotAddEditPpot.vue?vue&type=script&lang=js&"
export * from "./PsotAddEditPpot.vue?vue&type=script&lang=js&"
import style0 from "./PsotAddEditPpot.vue?vue&type=style&index=0&id=3415f9e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3415f9e1",
  null
  
)

export default component.exports